import { useState, useEffect } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import User from 'utils/user.util';

const ReportsSettings = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [reportsURL, setReportsURL] = useState('');

    const fetchURL = async ({ forceRefresh = false }) => {
        try {
            const token = User.getToken();
            const response = await fetch(
                `${process.env.REACT_APP_PROXY_URL || ''}/api/reports/url?refresh=${forceRefresh}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);
            const data = await response.json();
            setReportsURL(data.url || '');
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };

    useEffect(() => {
        fetchURL({ forceRefresh: false });
    }, []);

    return (
        <div className="reports-settings">
            <h3 className="mb-4">{t('reports_settings')}</h3>
            <p>{reportsURL}</p>
            <Button
                variant="primary"
                disabled={loading}
                onClick={() => {
                    setLoading(true);
                    fetchURL({ forceRefresh: true });
                }}
            >
                {loading ? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />{' '}
                        {t('loading')}
                    </>
                ) : (
                    t('fetch_reports_url')
                )}
            </Button>
        </div>
    );
};

export default ReportsSettings;
